<div
  class="flex flex-col justify-center items-center gap-4 min-h-screen bg-[#0f2b5e] text-white text-center px-4">
  @if (error()) {
    <h1 class="font-bold text-3xl">Sign-in failed</h1>
    <p class="max-w-md text-white/80">{{ error() }}</p>
  } @else {
    <h1 class="font-bold text-3xl">Almost there</h1>
    <p class="max-w-md text-white/80">Completing sign-in…</p>
  }
</div>
